module.exports = __webpack_public_path__ + "media/images/mobile/home/list_b1-6a99b9e441cdb5436b390cd0bdd4e60d.png";